import { render, staticRenderFns } from "./GiftCharge.html?vue&type=template&id=6ff164fe&external"
import script from "./GiftCharge.js?vue&type=script&lang=js&external"
export * from "./GiftCharge.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports